import { createAction } from 'utils/redux'

export const receiveLandingPages = (settings) =>
  createAction({
    type: 'RECEIVE_LANDING_PAGES',
    settings,
  })

export const receiveLandingPageSubdomain = (subdomain) =>
  createAction({
    type: 'RECEIVE_LANDING_PAGES_SUBDOMAIN',
    subdomain,
  })

export const receiveLandingPageIntegrations = (data) =>
  createAction({
    type: 'RECEIVE_LANDING_PAGE_INTEGRATIONS',
    data,
  })

export const receiveLandingPageCname = (data) =>
  createAction({
    type: 'RECIEVE_LANDING_PAGE_CNAME',
    data,
  })

export const updateLandingPages = (settings) =>
  createAction({
    type: 'UPDATE_LANDING_PAGES',
    settings,
  })
